import { render, staticRenderFns } from "./EDialogDetalhesAulaInfantil.vue?vue&type=template&id=968591a0"
import script from "./EDialogDetalhesAulaInfantil.vue?vue&type=script&lang=js"
export * from "./EDialogDetalhesAulaInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports